import dayjs from "dayjs";

export const convertSecondsToDate = (seconds) => {
  return dayjs(seconds * 1000).format("YYYY-MM-DD");
};

export const convertSecondsToDateTime = (seconds) => {
  return dayjs(seconds * 1000).format("YYYY-MM-DD HH:mm");
};

export const convertDateToSeconds = (date) => {
  return dayjs(date).unix();
};

export const convertDateToDateTime = (date, withSeconds = false) => {
  return dayjs(date).format("YYYY-MM-DD HH:mm");
};
